import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link} from 'react-router-dom';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
class Home extends React.Component {
    componentDidMount() {
        // ReactGA.initialize('UA-157984080-1');
        // ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('3847665161963731');
        ReactPixel.pageView();
    }
 render(){
    return (
    <React.Fragment>
    <Helmet htmlAttributes>
        <title>PTE Writing Test Practice Material | LA Academy India</title>
        <meta name="description" content="Enhance your PTE writing abilities with our PTE writing test practice materials. LA Language Academy offers comprehensive resources for mastering the PTE Writing Test." />
        <meta name="twitter:title" content="PTE Writing Practice Test Material | Best PTE Writing Sample Test For Practice" />
        <meta name="og:title" content="PTE Writing Practice Test Material | Best PTE Writing Sample Test For Practice" />
        <meta name="twitter:description" content="Does PTE writing test seem daunting to you? Do you fear that you might fail to obtain your target score in PTE academic just because of the writing module? Don't get worried! Regularly practicing with PTE writing sample questions can help you overcome the challenges. To get the best PTE writing practice test material to boost your preparation, you can contact us at info@languageacademy.com.au." />
        <meta property="og:description" content="Does PTE writing test seem daunting to you? Do you fear that you might fail to obtain your target score in PTE academic just because of the writing module? Don't get worried! Regularly practicing with PTE writing sample questions can help you overcome the challenges. To get the best PTE writing practice test material to boost your preparation, you can contact us at info@languageacademy.com.au." />
    </Helmet>
    <div class="innerPage">
    <Header />

    <section class="bannerOuter">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h1>Polish your English Writing skills with the PTE Writing Practice Test Material</h1>
                        <span>Get the best PTE writing sample test material to enhance your exam preparation</span><br />
                        <a href="javascript:;" class="downArrow"><img src="images/banner-arrow.png" alt="banner-arrow" /></a>
                    </div>
                </div>
            </div>
        </section>
    </div>
      <section class="pteInfo">
         <div class="container">
                <div class="row">
                    <div class="col-lg-10 col-lg-offset-1">
                  <p class="web-content">
                     PTE writing test can seem intimidating to the people who have not written any piece of content ever after their school days. Developing excellent writing skills is a gradual process that demands perseverance and consistent practice. After a long break in this crucial process when the aspirants need to pass the writing module of the PTE exam to accomplish their dream of permanent residency in an English speaking country, they feel downcast. If you find yourself in the same situation, don't get disheartened. You can still improve your writing part if you follow an appropriate strategy and prepare religiously using the right PTE writing practice material.
                  </p>
                  <p class="web-content">
                     As there are plenty of PTE writing sample questions and study material available online, it is quite essential to choose the appropriate preparation resources that can help you sail through the exam. To have a proper strategy for your PTE exam practice writing, you can get in touch with the expert trainers and discuss your doubts with them. The experienced tutors can guide you thoroughly on how to utilize the PTE writing material and practice tests for maximum improvement.
                  </p>
                <p class="web-content">
                 After finding the right study resources and PTE coaching experts, the preparation for the writing module will not seem daunting anymore. Your focused preparation with the best PTE writing practice test sets will surely drive you to success.
                </p>
                <p class="web-content">
                Do you also want to hone your English writing skills and searching for the top-notch <a href="https://www.languageacademy.com.au/training/centre-parramatta/best-pte-coaching-classes-institute.html">PTE coaching classes</a> that can help you achieve your aim? Give us a call on <a style={{color: 'rgb(81, 203, 206)'}} href="tel:+61426230061" target="blank">+61 426230061</a> and get the latest PTE academic writing practice test material to boost your preparation.
                </p>
                     </div>
            </div>
         </div>
      </section>
    <section id="pte-modules">
         <div class="container">
            <div class="row text-center">
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-listening-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/listening.png" alt="images" class="listening" />
                        </div>
                        <h3 class="module-title">Listening</h3>
                        <p class="module-description">Start preparing for the listening section using the latest practice material.</p>
                     </div>
                  </Link>
               </div>
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-reading-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/reading.png" class="reading" />
                        </div>
                        <h3 class="module-title">Reading</h3>
                        <p class="module-description">Get the intensive PTE reading practice material to skyrocket your score.</p>
                     </div>
                  </Link>
               </div>
               <div class="col-lg-4 col-sm-4">
                  <Link to="/pte-speaking-test-practice-material">
                     <div class="module-wrapper">
                        <div class="module-icon">
                           <img src="images/speaking.png" class="speaking" />
                        </div>
                        <h3 class="module-title">Speaking</h3>
                        <p class="module-description">Get the guidance from our experts and remove all the hurdles that you face in PTE speaking test module.</p>
                     </div>
                  </Link>
               </div>
            </div>
         </div>
      </section>
    <WhyLove />
    <Testimonial />
    <Footer />
    </React.Fragment>);
    }
}

export default Home;
